module.exports = __webpack_public_path__ + "img/jb.e744ff02.png";